import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { deletePurchaseOrderInvoiceApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const deletePurchaseOrderInvoice = createAsyncThunk('deletePurchaseOrderInvoice', async (payload) => {
  return await deletePurchaseOrderInvoiceApi(payload);
});

const deletePurchaseOrderInvoiceSlice = createSlice({
  name: 'deletePurchaseOrderInvoice', // Unique Name
  initialState,
  reducers: {
    deletePurchaseOrderInvoiceReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(deletePurchaseOrderInvoice.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(deletePurchaseOrderInvoice.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(deletePurchaseOrderInvoice.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { deletePurchaseOrderInvoiceReset } = deletePurchaseOrderInvoiceSlice.actions;

export default deletePurchaseOrderInvoiceSlice.reducer;
